import { useRouter } from 'next/router'
import { useEffect } from 'react'

export function useResetFocusOnRouteChange(): void {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = () => {
      const { activeElement } = document

      if (activeElement instanceof HTMLElement) {
        activeElement.blur()
      }
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])
}
